import { render, staticRenderFns } from "./OwnersFormPopup.vue?vue&type=template&id=490e5a0b&scoped=true&"
import script from "./OwnersFormPopup.vue?vue&type=script&lang=js&"
export * from "./OwnersFormPopup.vue?vue&type=script&lang=js&"
import style0 from "./OwnersFormPopup.vue?vue&type=style&index=0&id=490e5a0b&prod&lang=scss&"
import style1 from "./OwnersFormPopup.vue?vue&type=style&index=1&id=490e5a0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490e5a0b",
  null
  
)

export default component.exports